import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  encodeStatisticsDateFilter,
  getStatisticsYearDateRange,
  matchStatisticsDateFilterYear,
  parseStatisticsDateFilter,
} from './dateFilterPresets';
import StatisticsYearRadioGroup from './StatisticsYearRadioGroup';

interface Props {
  attributeName: string;
  fallbackYear: number;
  pageAttribute?: string;
  years: number[];
}

export default function YearPresetDateFilter({
  attributeName,
  fallbackYear,
  pageAttribute,
  years,
}: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedDateRange = parseStatisticsDateFilter(
    searchParams,
    attributeName
  );
  const selectedYear = selectedDateRange
    ? matchStatisticsDateFilterYear({
        dateRange: selectedDateRange,
        years,
      })
    : fallbackYear;

  return (
    <StatisticsYearRadioGroup
      inputName={attributeName}
      selectedYear={selectedYear}
      years={years}
      onSelect={(year) => {
        const nextSearchParams = new URLSearchParams(searchParams.toString());

        nextSearchParams.set(
          attributeName,
          encodeStatisticsDateFilter(
            attributeName,
            getStatisticsYearDateRange(year)
          )
        );
        nextSearchParams.delete('page');

        if (pageAttribute) {
          nextSearchParams.delete(pageAttribute);
        }

        setSearchParams(nextSearchParams);
      }}
    />
  );
}
